import { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import { DecorativeText, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsTitle = (props: Props) => {
  const { children, palette = 'dark-kale' } = props;

  // ─── Styles ──────────────────────────────────────────────────────────

  const titleStyles =
    palette === 'white' ? styles.titleWhite : styles.titleKale;

  // ─────────────────────────────────────────────────────────────────────

  return (
    <DecorativeText sizeMatch={['36', '48']} style={titleStyles} bold>
      {children}
    </DecorativeText>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  titleWhite: {
    color: theme.colors.WHITE,
  },
  titleKale: {
    color: theme.colors.KALE,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  palette?: Palette;
}>;

type Palette = 'white' | 'kale';
